<template>
  <svg class="icon" width="14" height="9" viewBox="0 0 14 9" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="2.35522" y="0.790894" width="9.18122" height="2.02787" transform="rotate(45 2.35522 0.790894)" fill="#0C4897"/>
    <rect x="13.906" y="2.22485" width="9.18122" height="2.02787" transform="rotate(135 13.906 2.22485)" fill="#0C4897"/>
  </svg>
</template>